export const getResponsesForDomain = (domain, responses) => {
  if (!domain) return [];
  const allQuestionIds = domain.practices?.flatMap((p) => p.questions.map((q) => q.id)) || [];
  return responses.filter((r) => allQuestionIds.includes(r.question));
};

export const getDomainProgress = (domain, responses) => {
  if (!domain) return { total: 0, answered: 0, percentage: 0 };

  const allQs = domain.practices?.flatMap((p) => p.questions) || [];
  const total = allQs.length;

  const answered = allQs.filter((q) => {
    const r = responses.find((res) => res.question === q.id);
    if (!r?.answer) return false;
    if (r.answer === 'No') return true;
    if (r.answer === 'Yes') {
      const hasEvidence = r.evidence?.trim();
      const hasFiles = (r.backendFiles?.length || 0) + (r.newFiles?.length || 0) > 0;
      const hasFailed = (r.newFiles || []).some((f) => f.status === 'failed');
      return Boolean(hasEvidence && hasFiles && !hasFailed);
    }
    return false;
  }).length;

  const percentage = total ? Math.round((answered / total) * 100) : 0;
  return { total, answered, percentage };
};